import { Col, Row } from 'antd'
import { Text } from 'components/Text'
import styled from 'styled-components'

export const SignInFormGroup = styled.div`
	margin-bottom: 30px;
`

export const SignInFormText = styled(Text)`
	font-size: 14px;
	margin-bottom: 6px;
`

export const SignInFormGroupInput = styled.div`
	margin-top: 25px;
`

export const SignInFormGroupAction = styled.div`
	margin-top: 25px;
`
